import TextableModel from '../TextableModel';

export default class Model extends TextableModel {

    constructor(opts = {}) {
        super();
        this.defineAllProperties();

        this.backgroundImage = "/images/smile.png";
        this.borderWidth = 0;

        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    getType() {
        return "PictureModel";
    }
}
